import { useSession } from "@sg-protect/shell";
import { type PropsWithChildren } from "react";
import { Navigate } from "react-router";
import { useIsMigrationProjectEnabled } from "#hooks/useIsMigrationProjectEnabled.ts";
import { usePaths } from "#paths.ts";

export function MigrationProjectsAccessBoundary({ children }: PropsWithChildren) {
    const { products } = useSession();
    const isMigrationProjectEnabled = useIsMigrationProjectEnabled();
    const paths = usePaths();

    if (products?.migrationProjects.hasAccess === false || !isMigrationProjectEnabled) {
        return <Navigate to={paths.root} replace />;
    }

    return children;
}
